// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const oricorio_baile: PokeData = {
  "id": 741,
  "name": "oricorio-baile",
  "height": 6,
  "weight": 34,
  "base_experience": 167,
  "types": [
    PokeType.FIRE,
    PokeType.FLYING
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "growl",
    "peck",
    "agility",
    "mirror-move",
    "baton-pass",
    "flatter",
    "helping-hand",
    "feather-dance",
    "teeter-dance",
    "air-cutter",
    "roost",
    "air-slash",
    "captivate",
    "acrobatics",
    "hurricane",
    "revelation-dance"
  ],
  "moves": [
    "growl",
    "peck",
    "flatter",
    "roost",
    "air-slash",
    "acrobatics",
    "hurricane",
    "fire-fang",
    "morning-sun",
    "fire-punch",
    "aerial-ace",
    "blaze-kick",
    "fire-spin"
  ],
  "evolution_chain": {
    "id": 381,
    "item": null,
    "species": [
      {
        "name": "oricorio",
        "order": 741,
        "types": [
          PokeType.FIRE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 110,
    "speed": 141,
    "ability_power": 149
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
